import { useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { hasExplicitAnalyticsConsent } from "@/lib/cookieConsent";
import {
  buildPublicAnalyticsPayload,
  type PublicAnalyticsEventPlacement,
} from "@/lib/publicAnalytics";

export type { PublicAnalyticsEvent } from "@/lib/publicAnalytics";

export function usePublicAnalytics() {
  const track = useCallback(
    async (...[eventType, placement]: PublicAnalyticsEventPlacement) => {
      try {
        if (!hasExplicitAnalyticsConsent(() => window.localStorage)) return;

        const payload = buildPublicAnalyticsPayload(
          eventType,
          placement,
          window.location.pathname,
        );
        if (!payload) return;

        const { error } = await supabase.from("analytics_events").insert(payload);

        if (error && import.meta.env.DEV) {
          console.warn("[public-analytics]", error.message);
        }
      } catch {
        // Public telemetry is best-effort.
      }
    },
    [],
  );

  return { track };
}
